import type { FC } from 'react';
import React from 'react';

interface DividerSmallProps {
  className: string;
}

const DividerSmall: FC<DividerSmallProps> = ({ className }) => (
  <svg width={19} height={19} viewBox="0 0 19 19" className={className}>
    <path
      fillRule="evenodd"
      d="M16.8 4c.11 0 .2.09.2.2v2.6a.2.2 0 0 1-.2.2h-.6a.2.2 0 0 1-.2-.2V5H3v1.8a.2.2 0 0 1-.2.2h-.6a.2.2 0 0 1-.2-.2V4.2c0-.11.09-.2.2-.2h14.6zM2.2 15a.2.2 0 0 1-.2-.2v-2.6c0-.11.09-.2.2-.2h.6c.11 0 .2.09.2.2V14h13v-1.8c0-.11.09-.2.2-.2h.6c.11 0 .2.09.2.2v2.6a.2.2 0 0 1-.2.2H2.2zm2-6h10.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H4.2a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2z"
    />
  </svg>
);

export default DividerSmall;
